

import fetch from '../../fetch';
import React from 'react';

import utils from '../../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号',width: 50},
    {key:'prefix', label: '科目编号前缀'},
    {key:'name', label: '科研标准名称'},
    {key:'note', label: '预算标准描述', width: 240}
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('ky/base/budgetStandard/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/base/budgetStandard/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('ky/base/budgetStandard/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '预算标准添加成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到管理页面！</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('ky/base/budgetStandard/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '预算标准更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到管理页面！</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('ky/base/budgetStandard/remove/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                        DataGrid.selections = [];
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

const yuzhiScoreShow = () => {
    return fetch.get('platform/param/get/yuzhiScoreShow') 
    .then(response => {
        if(response.code === 200) {
            return response.payload.data
        }
    });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'sysparam'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}


/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
 const updateByParamName = (data) => {
    return fetch.post('platform/param/updateByParamName', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '系统参数信息更新成功!',
                content: (
                    <div>
                        <p>书院启动参数已变动，请查看相应页面核对！</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
    });
}

const passwordComplexity = () => {
    return fetch.get('platform/param/get/passwordComplexity') 
    .then(response => {
        if(response.code === 200) {
            return response.payload.data
        }
    });
}

export default {
    insertURL: '#/sysparam/insert',
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    yuzhiScoreShow,
    updateByParamName,
    passwordComplexity
}